import Rollbar from "rollbar";

import packageFile from "../../../../../package.json";

let person;
const storedUserInfo = localStorage.getItem("userInfo");

if (storedUserInfo) {
  try {
    /**
     * @type {Plug.User}
     */
    const userInfo = JSON.parse(storedUserInfo);
    const username = `${userInfo.firstName} ${userInfo.lastName}`;

    person = {
      id: userInfo.id,
      email: userInfo.email,
      username,
    };
  } catch (error) {
    console.error("Error parsing userInfo from localStorage:", error);
  }
}

/**
 * @type {import("rollbar").Configuration}
 */
export const rollbarConfig = {
  uncaughtErrorLevel: "warning",
  captureIp: "anonymize",
  autoInstrument: {
    log: false,
    connectivity: false,
    contentSecurityPolicy: true,
    dom: true,
    navigation: true,
    network: true,
  },
  enabled: process.env.REACT_APP_ROLLBAR_ENABLED === "true",
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV,
  code_version: packageFile.version,
  itemsPerMinute: 5,
  maxItems: 3,
  payload: {
    person,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
    server: {
      host: window.location.hostname,
      root: window.location.origin,
    },
  },
};

export const rollbar = new Rollbar(rollbarConfig);
